/* eslint-disable no-plusplus */
import React, { useRef, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useHistory } from 'react-router-dom';
import { useToast } from '../../../../hooks/toast';
import { useAuth } from '../../../../hooks/auth';

import { Container, Content, ContentArea, FormContainer } from './styles';

import api from '../../../../services/api';

import LeftMenu from '../../../../components/LeftMenu';
import InputWithLabel from '../../../../components/InputWithLabel';
import TextArea from '../../../../components/TextArea';
import Button from '../../../../components/Button';

interface AdminImplantationFormData {
  attendance_date: string;
  folder: string;
  description: string;
}

interface Client {
  id: string;
  name: string;
}

interface ClientProcess {
  id: string;
  process_number: string;
  folder: string;
  client: Client;
  attendance_type_id: string;
}

interface Location {
  id: string;
  client: Client;
  client_process: ClientProcess;
  process_attendance_id: string;
  deadline: string;
}

interface ProcessAttendance {
  clientProcess: ClientProcess;
}

const FinishAdminImplantationListItem: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const { user } = useAuth();

  const [clientProcess, setClientProcess] = useState<ClientProcess>();

  const locationState: Location = location.state as Location;

  console.log('Location', location);

  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();

  useEffect(() => {
    if (locationState) {
      setClientProcess(locationState.client_process);
      formRef.current?.setData({ folder: locationState.client_process.folder });
      // formRef.current?.setData({ attendance_date: locationState.deadline });
      formRef.current?.setData({
        attendance_date: new Date().toISOString().slice(0,10)
      });
    }
  }, [locationState]);

  console.log('client process', clientProcess);

  // const adminImplantationIdProd = '6b55218a-defa-429e-b597-e0a094ad59df';
  // const implantedIdProd = '8f15c77e-b765-4b28-a450-ca808710146d';
  // const adminImplantationIdDev = '3cdfffa7-7cf6-420e-80f4-f8b67352f7ad';
  // const implantedIdDev = '7db193de-04e3-4e29-bd92-ec371aed6ea9';

  const handleSubmit = useCallback(
    async (data: AdminImplantationFormData) => {
      try {
        // console.log(attendanceType);
        // console.log(clientProcess);

        if (clientProcess) {
          // await api.put('/process-attendance', {
          //   id: locationState.process_attendance_id,
          //   client_id: locationState.client.id,
          //   attendance_type_id: adminImplantationIdProd,
          //   client_process_id: clientProcess?.id,
          //   description: data.description,
          //   attendance_date: data.attendance_date,
          // });
          const attendanceType = await api.get(
            '/attendance-types/name/Implantação Administrativa',
          );

          await api.put('/admin-implantation-list', {
            id: locationState.id,
            client_id: locationState.client.id,
            client_process_id: clientProcess?.id,
            deadline: data.attendance_date,
            done: true,
          });

          /**
           * Após atualizar o andamento do processo e dar o ítem da lista como concluído, um andamento implantado deve ser criado
           */

          await api.post('/process-attendance', {
            client_id: locationState.client.id,
            //attendance_type_id: implantedIdProd,
            attendance_type_id: attendanceType.data.id,
            client_process_id: clientProcess?.id,
            description: data.description,
            attendance_date: format(new Date(), " yyyy'-'MM'-'dd", {
              locale: ptBR,
            }),
            user_id: user.id,
          });

          history.push('/admin-implantation-list');

          addToast({
            type: 'success',
            title: 'Lista finalizada!',
            description: 'Lista de implantação administrativa finalizada',
          });
        }
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao finalizar lista de implantação administrativa',
          description:
            'Ocorreu um erro ao finalizar lista de implantação administrativa.',
        });
      }
    },
    [
      addToast,
      clientProcess,
      history,
      locationState.client.id,
      locationState.id,
      user.id,
    ],
  );

  return (
    <Container>
      <Content>
        <LeftMenu />
        <ContentArea>
          <h1>Implantação Administrativa</h1>

          <Form ref={formRef} onSubmit={handleSubmit}>
            <FormContainer>
              <InputWithLabel name="folder" label="Pasta" type="text" />

              <label>
                {clientProcess && clientProcess?.client.name}{' '}
                {clientProcess && ' - Processo: '}
                {clientProcess && clientProcess.process_number}
              </label>
            </FormContainer>

            <FormContainer>
              <InputWithLabel name="attendance_date" label="Data" type="date" />
            </FormContainer>

            <FormContainer>
              <TextArea
                name="description"
                label="Histórico"
                rows={3}
                cols={100}
              />
            </FormContainer>

            <Button type="submit">Salvar</Button>
          </Form>
        </ContentArea>
      </Content>
    </Container>
  );
};

export default FinishAdminImplantationListItem;
